import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNTreatment, CNTreatmentType } from './cntreatment';
import * as moment from 'moment';

@RegisterItem()
export class CNTreatmentLogo extends CNTreatment {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNTreatment.CNTreatmentLogo';
    }

    get type(): CNTreatmentType {
        return CNTreatmentType.Logo;
    }

    get sessionCount(): number {
        return parseInt(this.getProperty('sessionCount'), 10);
    }

    set sessionCount(count: number) {
        this.setProperty('sessionCount', count.toString());
    }

    get sessionDone(): number {
        return parseInt(this.getProperty('sessionDone'), 10);
    }

    set sessionDone(count: number) {
        this.setProperty('sessionDone', count.toString());
    }

    get agreementDate(): Date {
        if (this.getProperty('AgreementDate') === null) {
            this.setProperty('AgreementDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('AgreementDate'), 'DD/MM/YYYY').toDate();
    }

    set agreementDate(date: Date) {
        this.setProperty('AgreementDate', moment(date).format('DD/MM/YYYY'));
    }

    get agreementStartDate(): Date {
        if (this.getProperty('AgreementStartDate') === null) {
            this.setProperty('AgreementStartDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('AgreementStartDate'), 'DD/MM/YYYY').toDate();
    }

    set agreementStartDate(date: Date) {
        this.setProperty('AgreementStartDate', moment(date).format('DD/MM/YYYY'));
    }

    get agreementEndDate(): Date {
        if (this.getProperty('AgreementEndDate') === null) {
            this.setProperty('AgreementEndDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('AgreementEndDate'), 'DD/MM/YYYY').toDate();
    }

    set agreementEndDate(date: Date) {
        this.setProperty('AgreementEndDate', moment(date).format('DD/MM/YYYY'));
    }

    get appraisalDate(): Date {
        if (this.getProperty('AppraisalDate') === null) {
            this.setProperty('AppraisalDate', moment(new Date()).format('DD/MM/YYYY'));
        }
        return moment(this.getProperty('AppraisalDate'), 'DD/MM/YYYY').toDate();
    }

    set appraisalDate(date: Date) {
        this.setProperty('AppraisalDate', moment(date).format('DD/MM/YYYY'));
    }

    public clone(): any {
        return new CNTreatmentLogo();
    }
}
